<template>
  <v-card v-if="panelType === 'Panel'" max-width="500" class="mx-auto" style="border-radius: 0; border-right: 1px solid rgba(0, 0, 0, 0.12);">
    <v-toolbar color="primary" v-if="false" :height="config.filterHeaderHeight">
      <v-toolbar-title class="tertiary--text">{{ $t('filterHeader') }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-expansion-panels v-model="activePanel" multiple flat accordion hover tile>
      <v-expansion-panel v-for="(filter,i) in filters" :key="i">
        <v-expansion-panel-header>{{ translate(filter) }}</v-expansion-panel-header>
        <v-expansion-panel-content class="text-truncate text-no-wrap">
          <template v-if="filter.groupName === filter.name">
            <v-expansion-panels multiple flat accordion hover tile class="pa-0 ma-0">
              <v-expansion-panel v-for="(subFilter,i) in filter.items" :key="'sf'+i" class="pb-0 ma-0">
                <v-expansion-panel-header class="pa-0 my-0 ml-1 pr-1" style="min-height: 36px">{{ translate(subFilter.name) }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-checkbox class="pl-0 ml-0 py-0 my-0" v-model="activeFilters" :label="subFilterItem.name"
                              v-for="subFilterItem in subFilter.items"
                              :value="subFilterItem"
                              :key="'sfi'+subFilterItem.id"
                              dense/>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
          <template v-else>
            <v-checkbox class="py-0 my-0" v-model="activeFilters" :label="filterItem.name"
                        v-for="filterItem in filter.items"
                        :value="filterItem"
                        :key="filterItem.id"
                        dense/>
          </template>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
  <!-- panelType !== "Panel" -->
  <v-card v-else max-width="500" flat class="mx-auto" style="border-radius: 0; border-right: 1px solid rgba(0, 0, 0, 0.05);">
    <v-expansion-panels v-if="filters.length > 0" v-model="panel" multiple flat accordion hover tile>
      <v-expansion-panel v-for="(filter, i) in filters" :key="'f'+i">
        <v-expansion-panel-header class="primary--text font-weight-bold pb-0 pt-2 ma-0" style="min-height: 40px">
            {{ translate(filter) }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <template v-if="filter.groupName === filter.name">
            <v-expansion-panels multiple flat accordion hover tile class="pa-0 ma-0">
              <v-expansion-panel v-for="(subFilter,i) in filter.items" :key="'sf'+i" class="pb-0 ma-0">
                <v-expansion-panel-header class="pa-0 my-0 ml-1 pr-1" style="min-height: 36px">{{ translate(subFilter) }}
                </v-expansion-panel-header>

                <!-- Text does not wrap, long text runs out to the right and is truncated without dots -->
                <v-expansion-panel-content v-if="config.subNavigationLabelOverflowBehaviour === 'TRUNCATE'">
                  <v-checkbox class="pl-0 ml-0 py-0 my-0 text-truncate" v-model="activeFilters" :label="subFilterItem.name"
                              v-for="subFilterItem in subFilter.items"
                              :value="subFilterItem"
                              :key="'sfi'+subFilterItem.id"
                              dense/>
                </v-expansion-panel-content>

                <!-- Text does not wrap, long text runs out to the right and is truncated with three dots -->
                <v-expansion-panel-content v-if="config.subNavigationLabelOverflowBehaviour === 'ELLIPSIS'">
                  <v-checkbox class="pl-0 ml-0 py-0 my-0 text-truncate shorten-long-label" v-model="activeFilters" :label="subFilterItem.name"
                              v-for="subFilterItem in subFilter.items"
                              :value="subFilterItem"
                              :key="'sfi'+subFilterItem.id"
                              dense/>
                </v-expansion-panel-content>

                <!-- Text does wrap, there can be more than one line -->
                <v-expansion-panel-content v-if="config.subNavigationLabelOverflowBehaviour === 'WRAP'" class="flex-row flex-nowrap">
                  <v-checkbox class="pl-0 ml-0 py-0 my-0 wrap-long-label" v-model="activeFilters" :label="subFilterItem.name"
                              v-for="subFilterItem in subFilter.items"
                              :value="subFilterItem"
                              :key="'sfi'+subFilterItem.id"
                              dense/>
                </v-expansion-panel-content>

              </v-expansion-panel>
            </v-expansion-panels>
          </template>
          <template v-else>
            <v-checkbox class="py-0 my-0" v-model="activeFilters"
                        v-for="filterItem in filter.items"
                        :value="filterItem"
                        :key="filterItem.id"
                        dense>
              <template v-slot:label><span class="truncate" :style="labelStyle">{{ filterItem.name }}</span></template>
            </v-checkbox>
          </template>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-progress-linear v-else :indeterminate="true"></v-progress-linear>
  </v-card>
</template>

<script>
import remoteApi from "../services/remoteApi"
import {mapState} from "vuex";
// import {debounce} from "lodash"

export default {
  props: ['componentWidth','panelData'],
  name: "AssetFilterSidebar",
  computed: {
    ...mapState({
      searchQueryValues: state => state.search.searchQuery.currentSearchQueryValues,
      config: state => state.config.server.portalUIConfiguration,
    }),
    labelStyle() {
      return {
        width: this.componentWidth - 80 + 'px'
      }
    },
  },
  data() {
    return {
      panelType: 'List',
      filters: [],
      panel: [],
      activePanel: '',
      activeFilters: []
    }
  },
  methods: {
    updateQueries() {
      this.$store.commit('search/SET_KEYWORD_SEARCH_VALUE', this.activeFilters)
    },
    translate(filter){
      if(filter.translate){
        return this.$t(filter.name)
      }
      return filter.name
    }
  },
  watch: {
    activeFilters() {
      this.updateQueries()
    },
    //TODO move the active filters into the store, this is to strong coupled
    searchQueryValues(value) {
      if (value.length === 0) {
        this.activeFilters = []
      }
    }
  },
  created() {
      if(this.panelData){
          this.filters = this.panelData
          this.filters.forEach(f => {
              f.items.forEach(fi => fi.parent = f.id)
          })
          this.filters.forEach((element, index) => {
              if (element.open) {
                  this.panel.push(index)
              }
          })
      } else {
          remoteApi.loadAssetFilters(this.$i18n.locale).then(response => {
              this.filters = response.items
              this.filters.forEach(f => {
                  f.items.forEach(fi => fi.parent = f.id)
              })
              response.items.forEach((element, index) => {
                  if (element.open) {
                      this.panel.push(index)
                  }
              })
          })
      }
  }
}
</script>

<style>
.v-expansion-panel-content__wrap {
  padding-bottom: 0;
  /*padding-left: 14px;*/
}

.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 54px;
}

.v-label {
  font-size: 14px;
  line-height: 14px !important;
}

.shorten-long-label .v-label {
  text-overflow: ellipsis;
  overflow: hidden;
}

.wrap-long-label .v-label {
  padding-top: 3px;
  line-height: 18px !important;
  word-wrap: break-word;
}

.wrap-long-label .v-input__slot {
  align-items: flex-start;
  align-content: flex-start;
}

.v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
  display: inline-block;
}

.v-input--selection-controls.v-input {
  min-height: 28px;
}

.v-input__control {
  flex-direction: row;
  flex-wrap: nowrap;
}

/*.toolbar-title {*/
/*	color: inherit;*/
/*}*/
</style>